const directions = {
    UP: 1,
    DOWN: 2
};

const defaults = {
    duration: 400,
    easing: ( current_time, start_value, diff_value, duration ) => {
        return -diff_value * ( current_time /= duration ) * ( current_time - 2 ) + start_value;
    }
};

function setElementAnimationStyles(el) {
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
}

function removeElementAnimationStyles(el) {
    el.style.height = null;
    el.style.overflow = null;
    el.style.marginTop = null;
    el.style.marginBottom = null;
    el.style.paddingTop = null;
    el.style.paddingBottom = null;
}

function isInteger(value) {
    if ( Number.isInteger ) {
        return Number.isInteger( value );
    } else {
        return typeof value === 'number' && isFinite( value ) && Math.floor( value ) === value;
    }
}

function extend(a, b) {
    return Object.assign( {}, a, b );
}

function animate(el, options, now) {
    if ( !options.startTime ) {
        options.startTime = now;
    }

    const current_time = now - options.startTime;
    let animation_continue = current_time < options.duration;

    let new_height = options.easing(
        current_time,
        options.startingHeight,
        options.distanceHeight,
        options.duration
    );

    if ( animation_continue ) {
        el.style.height = `${ new_height.toFixed( 2 ) }px`;
        window.requestAnimationFrame(( timestamp ) => animate( el, options, timestamp ) );
    } else {
        if ( options.direction === directions.UP ) {
            el.style.display = 'none';
        }

        if ( options.direction === directions.DOWN ) {
            el.style.display = 'block';
        }

        removeElementAnimationStyles( el );
    }
}

function slideUp(el, args) {
    if ( isInteger( args ) ) {
        args = { duration: args };
    }

    setElementAnimationStyles( el );

    const options = extend( defaults, args );
    options.direction = directions.UP;
    options.to = 0;
    options.startingHeight = el.scrollHeight;
    options.distanceHeight = -options.startingHeight;

    window.requestAnimationFrame(( timestamp ) => animate( el, options, timestamp ) );
}

function slideDown(el, args) {
    if ( isInteger( args ) ) {
        args = { duration: args };
    }

    el.style.height = '0px';
    setElementAnimationStyles( el );

    const options = extend( defaults, args );
    options.direction = directions.DOWN;
    options.to = el.scrollHeight;
    options.startingHeight = 0;
    options.distanceHeight = options.to;

    window.requestAnimationFrame(( timestamp ) => animate( el, options, timestamp ) );
}

function toggleSlide(el, args) {
    const display = el.style.display || window.getComputedStyle( el ).display;

    if ( display === 'none' ) {
        slideDown( el, args );
    } else {
        slideUp( el, args );
    }
}

export {
    slideUp,
    slideDown,
    toggleSlide
};
